// en: us ca eu uk au za ph
// de fr it es nl mx br jp kr tw sa
// cn: 无  cis/ru 已经下线

export const i18n: Record<string, Record<string, string>> = {
    en: {
        cart_title: 'Shopping Cart',
        cart_empty: 'Your shopping cart is empty.',
        cart_coupon_copied: 'Copied',
        cart_coupon_countdown: 'Ends in',
        cart_ai_title: 'Recommended for you',
        cart_ai_add: 'Add',
        cart_footer_total: 'Total',
        cart_footer_subtotal: 'Subtotal',
        cart_footer_discount: 'Discount',
        cart_footer_gift: 'Gift Card',
        cart_footer_checkout: 'Checkout',
    },
    de: {
        cart_title: 'Warenkorb',
        cart_empty: 'Keine Produkte im Einkaufswagen.',
        cart_coupon_copied: 'Kopiert',
        cart_coupon_countdown: 'Endet in',
        cart_ai_title: 'Für Sie empfohlen',
        cart_ai_add: 'Hinzufügen',
        cart_footer_total: 'Gesamt',
        cart_footer_subtotal: 'Zwischensumme',
        cart_footer_discount: 'Rabatt',
        cart_footer_gift: 'Geschenkgutschein',
        cart_footer_checkout: 'Zur Kasse',
    },
    fr: {
        cart_title: 'Panier',
        cart_empty: 'Aucun produit dans le chariot.',
        cart_coupon_copied: 'Copié',
        cart_coupon_countdown: 'Se termine par',
        cart_ai_title: 'Recommandé pour vous',
        cart_ai_add: 'Ajouter',
        cart_footer_total: 'Total',
        cart_footer_subtotal: 'Sous-total',
        cart_footer_discount: 'Rabais',
        cart_footer_gift: 'Carte-cadeau',
        cart_footer_checkout: 'Procéder au paiement',
    },
    it: {
        cart_title: 'Carrello della spesa',
        cart_empty: 'Nessun prodotto nel carrello.',
        cart_coupon_copied: 'Copiato',
        cart_coupon_countdown: 'Termina in',
        cart_ai_title: 'Consigliato per te',
        cart_ai_add: 'Aggiungere',
        cart_footer_total: 'Totale',
        cart_footer_subtotal: 'Subtotale',
        cart_footer_discount: 'Sconto',
        cart_footer_gift: 'Carta regalo',
        cart_footer_checkout: 'Acquista',
    },
    es: {
        cart_title: 'Carrito de compras',
        cart_empty: 'No hay productos en el carrito.',
        cart_coupon_copied: 'Copiado',
        cart_coupon_countdown: 'Termina en',
        cart_ai_title: 'Recomendado para ti',
        cart_ai_add: 'Agregar',
        cart_footer_total: 'Total',
        cart_footer_subtotal: 'Subtotal',
        cart_footer_discount: 'Descuento',
        cart_footer_gift: 'Tarjeta regalo',
        cart_footer_checkout: 'Verificar',
    },
    nl: {
        cart_title: 'Winkelwagen',
        cart_empty: 'Uw winkelwagen is leeg.',
        cart_coupon_copied: 'Gekopieerd',
        cart_coupon_countdown: 'Eindigt over',
        cart_ai_title: 'Aanbevolen voor jou',
        cart_ai_add: 'Toevoegen',
        cart_footer_total: 'Totaal',
        cart_footer_subtotal: 'Subtotaal',
        cart_footer_discount: 'Korting',
        cart_footer_gift: 'Cadeaubon',
        cart_footer_checkout: 'Uitchecken',
    },
    jp: {
        cart_title: 'ショッピングカート',
        cart_empty: 'カート内に商品がありません。',
        cart_coupon_copied: 'コピー済',
        cart_coupon_countdown: '失効まで',
        cart_ai_title: 'おすすめ',
        cart_ai_add: '追加',
        cart_footer_total: '合計',
        cart_footer_subtotal: '小計',
        cart_footer_discount: '割引',
        cart_footer_gift: 'ギフトカード',
        cart_footer_checkout: 'ご購入手続きへ',
    },
    kr: {
        cart_title: '장바구니',
        cart_empty: '현재 장바구니가 비어 있습니다.',
        cart_coupon_copied: '복사됨',
        cart_coupon_countdown: '끝납니다',
        cart_ai_title: '추천 콘텐츠',
        cart_ai_add: '추가하다',
        cart_footer_total: '총',
        cart_footer_subtotal: '소계',
        cart_footer_discount: '할인',
        cart_footer_gift: '기프트 카드',
        cart_footer_checkout: '결제',
    },
    mx: {
        cart_title: 'Carrito de compras',
        cart_empty: 'No hay productos en el carrito.',
        cart_coupon_copied: 'Copiado',
        cart_coupon_countdown: 'Termina en',
        cart_ai_title: 'Recomendado para ti',
        cart_ai_add: 'Agregar',
        cart_footer_total: 'Total',
        cart_footer_subtotal: 'Subtotal',
        cart_footer_discount: 'Descuento',
        cart_footer_gift: 'Tarjeta de regalo',
        cart_footer_checkout: 'Verificar',
    },
    br: {
        cart_title: 'Carrinho de supermercado',
        cart_empty: 'Sem produtos no carrinho.',
        cart_coupon_copied: 'Copiado',
        cart_coupon_countdown: 'Termina em',
        cart_ai_title: 'Recomendado para você',
        cart_ai_add: 'Adicionar',
        cart_footer_total: 'Total',
        cart_footer_subtotal: 'Subtotal',
        cart_footer_discount: 'Desconto',
        cart_footer_gift: 'Cartão Presente',
        cart_footer_checkout: 'Finalizar Compra',
    },
    sa: {
        cart_title: 'سلة التسوق',
        cart_empty: 'سلة التسوق فارغة',
        cart_coupon_copied: 'تم النسخ',
        cart_coupon_countdown: 'ينتهي خلال',
        cart_ai_title: 'مقترح لك',
        cart_ai_add: 'إضافة',
        cart_footer_total: 'المجموع',
        cart_footer_subtotal: 'المجموع الجزئي',
        cart_footer_discount: 'الخصم',
        cart_footer_gift: 'بطاقة الهدية',
        cart_footer_checkout: 'إتمام الشراء',
    },
    tw: {
        cart_title: '購物車',
        cart_empty: '您的購物車是空的',
        cart_coupon_copied: '已複製',
        cart_coupon_countdown: '距離結束',
        cart_ai_title: '為您推薦',
        cart_ai_add: '加入',
        cart_footer_total: '總計',
        cart_footer_subtotal: '小計',
        cart_footer_discount: '折扣',
        cart_footer_gift: '禮品卡',
        cart_footer_checkout: '前往結帳',
    },
};
